import { render, staticRenderFns } from "./DataVisualization.vue?vue&type=template&id=1ad64661&scoped=true&"
import script from "./dataVisualization.js?vue&type=script&lang=js&"
export * from "./dataVisualization.js?vue&type=script&lang=js&"
import style0 from "./DataVisualization.vue?vue&type=style&index=0&id=1ad64661&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad64661",
  null
  
)

export default component.exports